// extracted by mini-css-extract-plugin
module.exports = {"card":"SmptAndroidPos_card__1mTDE","text":"SmptAndroidPos_text__QelVE","text-ltr":"SmptAndroidPos_text-ltr__2aqNy"};